module.exports = __webpack_public_path__ + "static/media/wcloud.1098bf7d.svg";